import React, { useContext } from "react";
import "devextreme/dist/css/dx.light.css";
import { ButtonGroup } from "devextreme-react";
import DateBox from "devextreme-react/date-box";
import "./dateRange.css";
import { DateContext } from "../navigation/navigationDrawer";
import Notify from 'devextreme/ui/notify';

function DateRange() {

  const { startDate, setStartDate, endDate, setEndDate, selectedDate, setSelectedDate } = useContext(DateContext);

  const dateRange = [
    {
      text: "Daily",
    },
    {
      text: "Weekly",
    },
    {
      text: "Monthly",
    },
    {
      text: "Yearly",
    },
  ];

  const handleDateClick = (date) => {
    setSelectedDate(date);
    const currentDate = new Date();
    let newStartDate, newEndDate;

    switch (date) {
      case dateRange[0]:
        newStartDate = new Date(currentDate);
        newStartDate.setHours(0, 0, 0, 0); // Set to today 00:00:00
        newEndDate = new Date(currentDate); // Set to today current time
        break;
      case dateRange[1]:
        newStartDate = new Date(currentDate);
        newStartDate.setDate(newStartDate.getDate() - 7); // Set to one week back
        newEndDate = new Date(currentDate);
        break;
      case dateRange[2]:
        newStartDate = new Date(currentDate);
        newStartDate.setMonth(newStartDate.getMonth() - 1); // Set to one month back
        newEndDate = new Date(currentDate);
        break;
      case dateRange[3]:
        newStartDate = new Date(currentDate);
        newStartDate.setFullYear(newStartDate.getFullYear() - 1); // Set to one year back
        newEndDate = new Date(currentDate);
        break;
      default:
        newStartDate = new Date(currentDate);
        newEndDate = new Date(currentDate);
    }
    setStartDate(newStartDate);
    setEndDate(newEndDate);
  };

  const currentDate = new Date();
  const endDateTime = new Date(currentDate);
  const handleStartDateChange = (date) => {
    if (date < endDateTime) {
      setStartDate(date);
      setSelectedDate({text:""});
    } else {
      Notify({
        message: "Start date must be before end date",
        type: 'error',
        displayTime: 3500,
        animation: {
          show: {
            type: 'fade', duration: 400, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      }, {
        position: 'bottom center',
        direction: 'up-push',
      });
    }
  };

  const handleEndDateChange = (date) => {
    if (date > startDate) {
      setEndDate(date);
      setSelectedDate({text:""});
    } else {
      Notify({
        message: "End date must be after start date",
        type: 'error',
        displayTime: 3500,
        animation: {
          show: {
            type: 'fade', duration: 400, from: 0, to: 1,
          },
          hide: { type: 'fade', duration: 40, to: 0 },
        },
      }, {
        position: 'bottom center',
        direction: 'up-push',
      });
    }
  };

  return (
    <div className="date-btn-group-container">
      <div className="date-group-container">
        <ButtonGroup
          items={dateRange}
          stylingMode="outlined"
          keyExpr="text"
          defaultSelectedItemKeys={"Daily"}
          onItemClick={(e) => handleDateClick(e.itemData)}
        />
      </div>
      <div className="date-picker-container">
        <div className="date-picker-wrapper">
          <DateBox
            defaultValue={startDate}
            value={startDate}
            onValueChange={(date) => handleStartDateChange(date)}
            type="date"
            label="Start Date"
            labelMode="floating"
          />
        </div>
        <div className="date-picker-wrapper">
          <DateBox
            defaultValue={endDate}
            value={endDate}
            onValueChange={(date) => handleEndDateChange(date)}
            type="date"
            label="End Date"
            labelMode="floating"
          />
        </div>
      </div>
    </div>
  );
}

export default DateRange;
